<div class="content tw:bg-cyan-lightest">
    <header>
      <nav>
        <button (click)="onClose()" class="fc-primary border-none">
          <vee-icon icon="close" class="tw:text-cyan"></vee-icon>
        </button>
      </nav>
    </header>
    
    <h1>{{ info.title }}</h1>
    <p>{{ info.info }}</p>
  </div>